// TODO: we changed the string so we can support both new and old intl settings
export const SET_CURRENT_LOCALE = '@@intl/UPDATE';
